import { createTheme } from '@material-ui/core/styles';

const colors = {
    //white: '#fafafa important',
}
export const theme = createTheme({
    palette: {
        //   primary: index
    },
    typography: {
        fontFamily: [
            'Roboto', 'sans-serif'
        ].join(','),
        subheading: {
            fontFamily: [
                'Roboto', 'sans-serif',
            ].join(',')
        },
        body2: {
            fontWeight: '600', // Change this to your desired font weight
        },
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '*::-webkit-scrollbar': {
                    width: '1em',
                    height: '0.45em'
                },
                '*::-webkit-scrollbar-track': {
                    '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0,0,0,.5)',
                    outline: '1px solid slategrey'
                },
            }
        },
        MuiDrawer: {

        },
        MuiFab: {
            secondary: {
                backgroundColor: '#00355f !important'
            },

        },
        MuiButton: {
            containedPrimary: {
                color: '#fafafa !important',
                backgroundColor: 'rgb(0,53,95) !important'
            },
        },

        MuiIcon: {
            root: {
                lineHeight: 'initial'
            }
        },

        MuiCheckbox: {
            colorPrimary: {
                color: '#1976d2 !important',
            },
            colorSecondary: {
                color: '#1976d2 !important',
            }
        },
        // MuiSwitch: {
        //     colorPrimary: {
        //         color: '#1976d2 !important',
        //     },
        //     colorSecondary: {
        //         color: '#1976d2 !important',
        //     }
        // },
        MuiAppBar: {
            colorPrimary: {
                color: colors.white,
                backgroundColor: '#212529 !important'
            },
            colorSecondary: {
                color: colors.white,
                backgroundColor: '#00355f !important'
            },
            colorDefault: {
                //color: '#fafafa !important',
                color: colors.white,
                backgroundColor: '#42a5f5 !important'
            }
        },
        MuiTypography: {
            body2: {
                fontSize: '0.8125rem',
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 600,
                lineHeight: 1.43,
            },
            subtitle2: {
                color: '#6c757d !important',
            },
            colorPrimary: {
                color: '#00355f'
            },
            colorSecondary: {
                color: '#1f1d1d !important'
            },
            section: {
                color: '#ffffff !important'
            }

        },
        MuiFormControl: {
            root: {
                zIndex: 'auto'
            }
        },
        MuiExpansionPanel: {
            root: {
                MuiExpanded: false
            }
        },
        MuiInputBase: {
            // root: {
            //     marginTop: '0px',
            //     color: 'grey'
            // }
        },
        MuiInputLabel: {
            formControl: {
                //color: 'grey',
                //  marginTop: '0px'
            }
        },
        // MuiInput:{
        //     formControl: {
        //         marginTop: '1px !important'
        //     }
        // },
        MuiLinearProgress: {
            root: {
                height: 5
            }
        },
        MuiTab: {
            root: {
                'text-transform': 'capitalize',
                minHeight: ''
            }
        },
        MuiIconButton: {
            root: {
                padding: '3px'
            },
            colorPrimary: {
                color: '#00355f !important'
            },
        },
        MuiAccordionDetails: {
            root: {
                padding: '0px'
            }
        },
        MuiMenu: {
            paper: {
                maxHeight: '250px'
            }
        },
        MuiPaper: {
            root: {
                borderRadius: '10px'
            }
        },
        MuiAccordion: {
            rounded: {
                borderRadius: '10px'
            }
        },
    }
});

export const aps_theme = createTheme({
    palette: {
        //   primary: index
    },
    typography: {
        fontFamily: [
            'Montserrat', 'sans-serif'
        ].join(','),
        subheading: {
            fontFamily: [
                'Montserrat', 'sans-serif',
            ].join(',')
        },
        h6: {
            color: "inherit"
        }
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '*::-webkit-scrollbar': {
                    // width: '0.6em',
                    // height: '0.45em'
                },
                '*::-webkit-scrollbar-track': {
                    '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0,0,0,.5)',
                    outline: '1px solid slategrey'
                },
            }
        },
        MuiDrawer: {

        },
        MuiFab: {
            secondary: {
                backgroundColor: '#074078 !important'
            },

        },
        MuiButton: {
            text: {
                textTransform: 'none',
            },
            containedPrimary: {
                color: '#fafafa !important',
                backgroundColor: '#074078 !important'
            },

            root: {
                textTransform: 'none'
            }
        },
        MuiIconButton: {
            /*  colorSecondary: {
                  backgroundColor: '#212529 !important'
              }*/
        },
        MuiIcon: {
            root: {
                lineHeight: 'initial'
            }
        },

        MuiCheckbox: {
            colorPrimary: {
                color: '#074078 !important',
            },
            colorSecondary: {
                color: '#074078 !important',
            }
        },
        // MuiSwitch: {
        //     colorPrimary: {
        //         color: '#074078 !important',
        //     },
        //     colorSecondary: {
        //         color: '#074078 !important',
        //     }
        // },
        MuiAppBar: {
            colorPrimary: {
                color: colors.white,
                backgroundColor: '#212529 !important'
            },
            colorSecondary: {
                color: colors.white,
                backgroundColor: '#074078 !important'
            },
            colorDefault: {
                //color: '#fafafa !important',
                color: colors.white,
                backgroundColor: '#42a5f5 !important'
            }
        },
        MuiTypography: {
            colorSecondary: {
                color: '#1f1d1d !important'
            }
        },
        MuiFormControl: {
            root: {
                zIndex: 'auto'
            }
        },
        MuiExpansionPanel: {
            root: {
                MuiExpanded: false
            }
        },
        MuiInputBase: {
            root: {
                marginTop: '0px',
                color: 'grey'
            }
        },
        MuiInputLabel: {
            formControl: {
                marginTop: '0px'
            },
            asterisk: {
                color: 'red',
            }
        },
        // MuiInput:{
        //     formControl: {
        //         marginTop: '1px !important'
        //     }
        // },
        MuiLinearProgress: {
            root: {
                height: 5
            }
        },
        MuiTab: {
            root: {
                'text-transform': 'capitalize'
            }
        },
        MuiIconButton: {
            root: {
                padding: '3px'
            }
        },
        MuiAccordionDetails: {
            root: {
                padding: '0px'
            }
        },
        MuiFormLabel: {
            root: {
                color: 'black',
                fontWeight: 'bold'
            }
        },
        MuiMenu: {
            paper: {
                maxHeight: '250px'
            }
        },
        MuiListItem: {
            root: {
                paddingTop: '1px !important',
                paddingBottom: '1px !important'
            },
            gutters: {
                paddingLeft: '0px !important',
                paddingRight: '8px !important'
            }
        }
    }
});

export const wrs_theme = createTheme({
    palette: {
        //   primary: index
    },
    typography: {
        fontFamily: [
            'Montserrat', 'sans-serif'
        ].join(','),
        subheading: {
            fontFamily: [
                'Montserrat', 'sans-serif',
            ].join(',')
        },
        h6: {
            color: "inherit"
        }
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '*::-webkit-scrollbar': {
                    width: '0.4em',
                    height: '0.45em'
                },
                '*::-webkit-scrollbar-track': {
                    '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: '#074078 !important',//'rgba(0,0,0,.5)',
                    outline: '1px solid #074078'
                },
            }
        },
        MuiDrawer: {

        },
        MuiFab: {
            secondary: {
                backgroundColor: '#074078 !important'
            },

        },
        MuiButton: {
            text: {
                textTransform: 'none',
            },
            containedPrimary: {
                color: '#fafafa !important',
                backgroundColor: '#074078 !important'
            },

            root: {
                textTransform: 'none'
            }
        },
        MuiIconButton: {
            /*  colorSecondary: {
                  backgroundColor: '#212529 !important'
              }*/
        },
        MuiIcon: {
            root: {
                lineHeight: 'initial'
            }
        },
        MuiRadio: {
            colorSecondary: {
                color: '#074078 !important',
            }
        },
        MuiCheckbox: {
            colorPrimary: {
                color: '#074078 !important',
            },
            colorSecondary: {
                color: '#074078 !important',
            }
        },
        MuiFab: {
            primary: {
                color: 'white !important',
                backgroundColor: '#074078 !important'
            },
            secondary: {
                backgroundColor: '#074078 !important',
                color: 'white !important'
            }
        },
        // MuiSwitch: {
        //     colorPrimary: {
        //         color: '#074078 !important',
        //     },
        //     colorSecondary: {
        //         color: '#074078 !important',
        //     }
        // },
        MuiAppBar: {
            colorPrimary: {
                color: colors.white,
                backgroundColor: '#074078 !important'
            },
            colorSecondary: {
                color: colors.white,
                backgroundColor: '#30699f !important'
            },
            colorDefault: {
                //color: '#fafafa !important',
                color: colors.white,
                backgroundColor: '#074078 !important'
            }
        },
        MuiTypography: {
            colorPrimary: {
                color: '#074078'
            },
            colorSecondary: {
                color: '#1f1d1d !important'
            },
            colorTextSecondary: {
                color: '#074078'
            }
        },
        // MuiTab: {
        //     textColorPrimary: {
        //         MuiSelected: { color: '#074078 !important' }
        //     }
        // },
        MuiBox: {
            root: {
                padding: '20px !important'
            }
        },
        MuiFormControl: {
            root: {
                zIndex: 'auto'
            }
        },
        MuiExpansionPanel: {
            root: {
                MuiExpanded: false
            }
        },
        MuiInputBase: {
            root: {
                marginTop: '0px',
                color: 'grey'
            }
        },
        MuiInputLabel: {
            formControl: {
                marginTop: '0px'
            },
            asterisk: {
                color: 'red',
            }
        },
        // MuiInput:{
        //     formControl: {
        //         marginTop: '1px !important'
        //     }
        // },
        MuiLinearProgress: {
            root: {
                height: 5
            }
        },
        MuiTab: {
            root: {
                'text-transform': 'capitalize'
            }
        },
        MuiIconButton: {
            root: {
                padding: '3px'
            }
        },
        MuiAccordionDetails: {
            root: {
                padding: '0px'
            }
        },
        MuiFormLabel: {
            root: {
                color: 'black',
                fontWeight: 'bold'
            }
        },
        MuiMenu: {
            paper: {
                maxHeight: '250px'
            }
        }
    }
});

export const forward_theme = createTheme({
    palette: {
        primary: {
            main: '#673ab7',
        },
        secondary: {
            main: '#673ab7',
        },
        error: {
            main: '#ab003c',
        },
        background: {
            default: '#fff',
        },
    },
    typography: {
        fontFamily: [
            'system-ui', 'sans-serif',
        ].join(','),
        subheading: {
            fontFamily: [
                'system-ui', 'sans-serif',
            ].join(',')
        },
        h6: {
            color: "inherit"
        },
        // h5: {
        //     color: "inherit"
        // },
        fontSize: 13,
        // fontWeightLight: 300,
        // fontWeightRegular: 400,
        // fontWeightMedium: 500,
    },
    overrides: {
        MuiContainer: {
            root: {
                maxWidth: {
                    xs: '100%',  // for screens smaller than 600px
                    sm: '600px',  // for screens larger than 600px
                    md: '960px',  // for screens larger than 960px
                    lg: '1280px',  // for screens larger than 1280px
                    xl: '1920px',  // for screens larger than 1920px
                },
            },
        },
        MuiCssBaseline: {
            '@global': {
                '*::-webkit-scrollbar': {
                    width: '0.3em',
                    height: '0.45em',
                },
                '*::-webkit-scrollbar-track': {
                    '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: 'grey',
                    borderRadius: '10px',
                    outline: '1px solid grey'
                },
                '*::-webkit-scrollbar-thumb:hover': {
                    width: '1em',
                },
                '*::-webkit-scrollbar:hover': {
                    width: '1em',
                },
            }
        },
        MuiButton: {
            text: {
                textTransform: 'none',
            },
            root: {
                textTransform: 'none',
                padding: 0
            },
            defaultProps: {
                size: 'small',
            },
        },
        MuiFab: {
            defaultProps: {
                size: 'small',
            },
            root: {
                borderRadius: '8px',
                size: 'small',
                boxShadow: 'none',
                padding: '0px !important'
            },
        },
        MuiIconButton: {
            defaultProps: {
                size: 'small',
                padding: '0px !important'
            },
            colorPrimary: {
                backgroundColor: 'linear-gradient(135deg, #0f5a9e 0%, #fafafa 100%)',
                borderRadius: '8px'
            }
        },
        MuiCheckbox: {
            defaultProps: {
                size: 'small',
            },
            root: {
                backgroundColor: 'white !important',
            }
        },
        MuiRadio: {
            defaultProps: {
                size: 'small',
            },
            root: {
                paddingTop: 8,
                backgroundColor: 'rgba(255, 255, 255,0)'// 50% transparent white
            }
        },
        MuiSwitch: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiSelect: {
            paddingTop: '3px !important',
            defaultProps: {
                size: 'small',
                margin: 'normal'
            },
        },
        MuiFilledInput: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiInputLabel: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiAutocomplete: {
            defaultProps: {
                size: 'small',
                margin: 'normal'
            },
        },
        MuiListItemIcon: {
            defaultProps: {
                size: 'small',
            },
            root: {
                minWidth: '30px !important'
            }

        },
        MuiListItemText: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiMenuItem: {
            defaultProps: {
                size: 'small',
                margin: 'normal'
            },
        },
        MuiCardContent: {
            defaultProps: {
                size: 'small',
                margin: 'normal'
            },
        },

        MuiAppBar: {
            colorPrimary: {
                backgroundColor: colors.white,
                color: '#212529'
            },
            colorSecondary: {
                backgroundColor: colors.white,
                color: '#00355f !important'
            },
            colorDefault: {
                //color: '#fafafa !important',
                backgroundColor: colors.white,
                color: '#42a5f5 !important'
            }
        },
        MuiToolbar: {
            root: {
                minHeight: '48px'
            },
            regular: {
                minHeight: '48px'
            },
            dense: {
                minHeight: '0px'
            }


        },
        MuiTypography: {
            body2: {
                fontWeight: 400,
            },
            caption: {
                color: '#grey !important',
                fontSize: '0.875rem !important',
                fontWeight: '500 !important',
                //  color: '#697586 !important',
                // fontSize: '1rem !important',
            },
            h6: {
                color: '#808080 !important',
                fontSize: '18px !important',
                fontWeight: '500 !important',
            },
            subtitle1: {
                color: '#808080 !important',
                fontWeight: '500 !important',
                fontSize: '0.875rem !important',
            },
            subtitle2: {
                fontWeight: '500 !important',
                fontSize: '0.875rem !important',
            },
            displayBlock: {
                display: 'block',
                color: 'black',
            },
            colorPrimary: {
                color: '#3f51b5'
            },
        },

        MuiExpansionPanel: {
            root: {
                MuiExpanded: false
            }
        },
        MuiFormGroup: {
            root: {
                [theme.breakpoints.up('xs')]: {
                    marginTop: '12px',  // for screens larger than 0px
                },
                [theme.breakpoints.up('sm')]: {
                    marginTop: '5px',  // for screens larger than 600px
                },
                [theme.breakpoints.up('md')]: {
                    marginTop: '5px',  // for screens larger than 960px
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: '2px',  // for screens larger than 1280px
                },
                [theme.breakpoints.up('xl')]: {
                    marginTop: '0px',  // for screens larger than 1920px
                },
            },
        },

        MuiInput: {
            defaultProps: {
                size: 'small',
                margin: 'normal'
            },
            root: {
                [theme.breakpoints.up('xs')]: {
                    marginTop: '25px',  // for screens larger than 0px
                },
                [theme.breakpoints.up('sm')]: {
                    marginTop: '20px',  // for screens larger than 600px
                },
                [theme.breakpoints.up('md')]: {
                    marginTop: '15px',  // for screens larger than 960px
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: '10px',  // for screens larger than 1280px
                },
                [theme.breakpoints.up('xl')]: {
                    marginTop: '5px',  // for screens larger than 1920px
                },
            }
        },

        MuiLinearProgress: {
            root: {
                height: 5
            }
        },
        MuiTabs: {
            root: {
                minHeight: '0px'
            }
        },
        MuiTab: {
            root: {
                'text-transform': 'capitalize',
            },
            textColorPrimary: {
                "&.Mui-selected": {
                    color: '#00355f !important',
                }
            },
        },

        MuiAccordionDetails: {
            root: {
                padding: '0px'
            }
        },
        MuiFormLabel: {
            root: {
                color: '#6c757d !important',
                fontWeight: '600'
            },
            asterisk: {
                color: 'red',
            }
        },
        MuiMenu: {
            paper: {
                maxHeight: '250px'
            }
        },
        PrivateTabIndicator: {
            colorPrimary: {
                color: '#00355f',
                backgroundColor: '#00355f'
            }
        },
        MuiMobileStepper: {
            dotActive: {
                backgroundColor: '#00355f'
            }
        },
        // MuiPaper: {
        //     root: {
        //         // borderRadius: '5px'
        //     }
        // },
        MuiListItem: {
            defaultProps: {
                size: 'small',
            },
            root: {
                '&:hover': {
                    backgroundColor: '#ede7f6 !important',  // Replace with your desired color
                    color: '#673ab7'
                },
                paddingTop: '1px !important',
                paddingBottom: '1px !important'
            },
            gutters: {
                paddingLeft: '0px !important',
            }
        },
        MuiButtonBase: {
            defaultProps: {
                size: 'small',
                margin: 'normal',
                padding: '0px',

            },
        },
        MuiBox: {
            root: {
                padding: '0px'
            }
        },
        PrivateSwitchBase: {
            root: {
                paddingLeft: '9px',
                paddingRight: '0px',
                paddingTop: '0px',
                paddingBottom: '5px',

            }
        }
    }
});

export const shapes_theme = createTheme({
    palette: {
        primary: {
            main: '#673ab7',
        },
        secondary: {
            main: '#673ab7',
        },
        error: {
            main: '#ab003c',
        },
        background: {
            default: '#fff',
        },
    },
    typography: {
        fontFamily: [
            'system-ui', 'sans-serif',
        ].join(','),
        subheading: {
            fontFamily: [
                'system-ui', 'sans-serif',
            ].join(',')
        },
        h6: {
            color: "inherit"
        },
        fontSize: 13,
        // fontWeightLight: 300,
        // fontWeightRegular: 400,
        // fontWeightMedium: 500,
    },
    overrides: {
        MuiContainer: {
            root: {
                maxWidth: {
                    xs: '100%',  // for screens smaller than 600px
                    sm: '600px',  // for screens larger than 600px
                    md: '960px',  // for screens larger than 960px
                    lg: '1280px',  // for screens larger than 1280px
                    xl: '1920px',  // for screens larger than 1920px
                },
            },
        },
        MuiCssBaseline: {
            '@global': {
                'input:-internal-autofill-selected': {
                    backgroundColor: 'transparent !important',
                    boxShadow: '0 0 0 1000px white inset !important',
                    '-webkit-box-shadow': '0 0 0 1000px white inset !important',
                    '-webkit-text-fill-color': '#000 !important',
                    paddingTop: '1px',
                    marginTop: '5px',
                },
                '*::-webkit-scrollbar': {
                    width: '0.3em',
                    height: '0.45em',
                },
                '*::-webkit-scrollbar-track': {
                    '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: 'grey',
                    borderRadius: '10px',
                    outline: '1px solid grey'
                },
                '*::-webkit-scrollbar-thumb:hover': {
                    width: '1em',
                },
                '*::-webkit-scrollbar:hover': {
                    width: '1em',
                },
            }
        },
        MuiFormControl: {
            root: {
                zIndex: 'auto',
                '&.Mui-required': {
                    borderColor: 'red',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    '& .MuiInputBase-root': {
                        borderColor: 'red',
                    },
                    '& .MuiInputLabel-root': {
                        color: 'red',
                    },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: 'red',
                        },
                    },
                },
            },
        },
        // MuiTextField: {
        //     defaultProps: {
        //         size: 'small',
        //         margin: 'normal'
        //     },
        // },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    backgroundColor: '#333',
                    color: '#fff',
                },
                arrow: {
                    color: '#333',
                },
                popper: {
                    zIndex: 1500,
                },
            },
            // defaultProps: {
            //     placement: 'top',
            //     arrow: true,
            // },
        },
        MuiButton: {
            text: {
                textTransform: 'none',
            },
            root: {
                textTransform: 'none'
            },
            // defaultProps: {
            //     size: 'small',
            // },
        },
        MuiFab: {
            // defaultProps: {
            //     size: 'small',
            // },
            root: {
                borderRadius: '8px',
                size: 'small',
                boxShadow: 'none',
                padding: '0px !important'
            },
        },
        MuiIconButton: {
            // defaultProps: {
            //     size: 'small',
            //     padding: '0px !important'
            // },
            colorPrimary: {
              backgroundColor: 'linear-gradient(135deg, #0f5a9e 0%, #fafafa 100%)',
                borderRadius: '8px'
            }
        },
        MuiCheckbox: {
            // defaultProps: {
            //     size: 'small',
            // },
            root: {
                backgroundColor: 'white !important',
            }
        },
        MuiRadio: {
            // defaultProps: {
            //     size: 'small',
            // },
            root: {
                paddingTop: 8,
                backgroundColor: 'rgba(255, 255, 255,0)',// 50% transparent white
            }
        },
        MuiSwitch: {
            // defaultProps: {
            //     size: 'small',
            // },
        },
        MuiSelect: {
            paddingTop: '3px !important',
            // defaultProps: {
            //     size: 'small',
            //     margin: 'normal'
            // },
        },
        MuiFilledInput: {
            // defaultProps: {
            //     size: 'small',
            // },
        },
        MuiInputLabel: {
            // defaultProps: {
            //     size: 'small',
            // },
        },
        MuiAutocomplete: {
            // defaultProps: {
            //     size: 'small',
            //     margin: 'normal'
            // },
        },
        // MuiFormControl: {
        //     defaultProps: {
        //         size: 'small',
        //         margin: 'normal'
        //     },
        // },
        MuiListItemIcon: {
            // defaultProps: {
            //     size: 'small',
            // },
            root: {
                minWidth: '30px !important'
            }

        },
        MuiListItemText: {
            // defaultProps: {
            //     size: 'small',
            // },
        },
        MuiMenuItem: {
            // defaultProps: {
            //     size: 'small',
            //     margin: 'normal'
            // },
        },
        MuiCardContent: {
            // defaultProps: {
            //     size: 'small',
            //     margin: 'normal'
            // },
        },
        // MuiFab: {
        //     root: {
        //         boxShadow: '0px 0px 2px 0px '
        //     },
        //     sizeSmall: {
        //         width: '30px',
        //         height: '30px',
        //         minHeight: '30px',
        //         padding: '0px'
        //     },
        //     primary: {
        //         color: '#00355f !important',
        //         backgroundColor: '#fafafa !important',
        //     },
        //     secondary: {
        //         color: '#00355f !important',
        //         backgroundColor: '#fafafa !important'
        //     },

        // },
        // MuiButton: {
        //     text: {
        //         textTransform: 'none',
        //     },
        //     textPrimary: {
        //         color: '#00355f',
        //     },
        //     containedPrimary: {
        //         color: '#fafafa !important',
        //         backgroundColor: '#00355f !important'
        //     },
        //     root: {
        //         textTransform: 'none'
        //     }
        // },
        // MuiIcon: {
        //     root: {
        //         lineHeight: 'initial'
        //     }

        // },

        // MuiCheckbox: {
        //     colorPrimary: {
        //         color: '#00355f !important',
        //     },
        //     colorSecondary: {
        //         color: '#00355f !important',
        //     }
        // },
        // MuiListItemIcon: {
        //     root: {
        //         minWidth: '35px'
        //     }
        // },
        // MuiSwitch: {
        //     colorPrimary: {
        //         color: '#1976d2 !important',
        //     },
        //     colorSecondary: {
        //         color: '#1976d2 !important',
        //     }
        // },
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: colors.white,
                color: '#212529'
            },
            colorSecondary: {
                backgroundColor: colors.white,
                color: '#00355f !important'
            },
            colorDefault: {
                //color: '#fafafa !important',
                backgroundColor: colors.white,
                color: '#42a5f5 !important'
            }
        },
        MuiToolbar: {
            root: {
                minHeight: '48px'
            },
            regular: {
                minHeight: '48px'
            },
            dense: {
                minHeight: '0px'
            }


        },
        MuiTypography: {
            body2: {
                fontWeight: 400,
            },
            caption: {
                color: '#grey',
                fontSize: '0.875rem !important',
                fontWeight: '500 !important',
                //  color: '#697586 !important',
                // fontSize: '1rem !important',
            },
            h6: {
                color: '#808080',
                fontSize: '18px !important',
                fontWeight: '500 !important',
            },
            subtitle1: {
                color: '#808080',
                fontWeight: '500 !important',
                fontSize: '0.875rem !important',
            },
            subtitle2: {
                fontWeight: '500 !important',
                fontSize: '0.875rem !important',
            },
            displayBlock: {
                display: 'block',
                color: 'black',
            },
            colorPrimary: {
                color: '#3f51b5'
            },
        },
        // MuiTypography: {
        //     colorPrimary: {
        //         color: '#00355f'
        //     },
        //     colorSecondary: {
        //         color: '#1f1d1d !important'
        //     },
        //     section: {
        //         color: '#ffffff !important'
        //     }

        // },
        // MuiFormControl: {
        //     root: {
        //         zIndex: 'auto',
        //         marginTop: '5px',
        //         // margin: '2px'
        //     }
        // },
        MuiExpansionPanel: {
            root: {
                MuiExpanded: false
            }
        },
        MuiFormGroup: {
            root: {
                [theme.breakpoints.up('xs')]: {
                    marginTop: '25px',  // for screens larger than 0px
                },
                [theme.breakpoints.up('sm')]: {
                    marginTop: '20px',  // for screens larger than 600px
                },
                [theme.breakpoints.up('md')]: {
                    marginTop: '15px',  // for screens larger than 960px
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: '10px',  // for screens larger than 1280px
                },
                [theme.breakpoints.up('xl')]: {
                    marginTop: '5px',  // for screens larger than 1920px
                },
            },
        },
        MuiFormControlLabel: {
            label: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
            root: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
        },
        MuiInputBase: {
            root: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
            input: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: 'black',
                        cursor: 'not-allowed',
                    },
                },
            },
            // defaultProps: {
            //     size: 'small',
            //     margin: 'normal'
            // },
            root: {
                [theme.breakpoints.up('xs')]: {
                    marginTop: '25px',  // for screens larger than 0px
                },
                [theme.breakpoints.up('sm')]: {
                    marginTop: '20px',  // for screens larger than 600px
                },
                [theme.breakpoints.up('md')]: {
                    marginTop: '15px',  // for screens larger than 960px
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: '10px',  // for screens larger than 1280px
                },
                [theme.breakpoints.up('xl')]: {
                    marginTop: '5px',  // for screens larger than 1920px
                },
            }
        },
        // MuiInputLabel: {
        //     root: {
        //         marginBottom: {
        //             xs: theme.spacing(1),  // for screens smaller than 600px
        //             sm: theme.spacing(2),  // for screens larger than 600px
        //             md: theme.spacing(3),  // for screens larger than 960px
        //             lg: theme.spacing(4),  // for screens larger than 1280px
        //             xl: theme.spacing(5),  // for screens larger than 1920px
        //         },
        //     },
        //     formControl: {
        //         marginTop: '0px'
        //     }
        // },
        MuiLinearProgress: {
            root: {
                height: 5
            }
        },
        MuiTabs: {
            root: {
                minHeight: '0px'
            }
        },
        MuiTab: {
            root: {
                'text-transform': 'capitalize',
            },
            textColorPrimary: {
                "&.Mui-selected": {
                    color: '#00355f !important',
                }
            },
        },
        MuiBox: {
            root: {
                padding: '0px'
            }
        },
        // MuiButtonBase: {
        //     // colorPrimary: {
        //     //     color: '#00355f !important',
        //     //     backgroundColor: '#fafafa !important',
        //     //     boxShadow: '0px 0px 2px 0px '
        //     // },
        //     // secondary: {
        //     //     color: '00355f !important',
        //     //     backgroundColor: '#fafafa !important',
        //     //     boxShadow: '0px 0px 2px 0px '
        //     // },
        //     // colorSecondary: {
        //     //     color: '00355f !important',
        //     //     backgroundColor: '#fafafa !important'
        //     // },
        // },
        // MuiIconButton: {
        //     root: {
        //         padding: '3px'
        //     }
        // },
        MuiAccordionDetails: {
            root: {
                padding: '0px'
            }
        },
        MuiFormLabel: {
            root: {
                color: '#6c757d',
                fontWeight: '600'
            },
            asterisk: {
                color: 'red',
            }
        },
        MuiMenu: {
            paper: {
                maxHeight: '250px'
            }
        },
        PrivateTabIndicator: {
            colorPrimary: {
                color: '#00355f',
                backgroundColor: '#00355f'
            }
        },
        MuiMobileStepper: {
            dotActive: {
                backgroundColor: '#00355f'
            }
        },
        MuiPaper: {
            root: {
                // borderRadius: '5px'
            }
        },
        MuiListItem: {
            // defaultProps: {
            //     size: 'small',
            // },
            root: {
                '&:hover': {
                    backgroundColor: '#ede7f6 !important',  // Replace with your desired color
                    color: '#673ab7'
                },
                paddingTop: '5px !important',
                paddingBottom: '5px !important'
            },
        },
        MuiButtonBase: {
            // defaultProps: {
            //     size: 'small',
            //     margin: 'normal',
            //     padding: '0px',

            // },
        },
        // MuiBox: {
        //     root: {
        //         padding: '0px'
        //     }
        // },   
        PrivateSwitchBase: {
            root: {
                paddingLeft: '9px',
                paddingRight: '0px',
                paddingTop: '0px',
                paddingBottom: '5px',

            }
        }
    }
});

export const mps_theme = createTheme({
    palette: {
        primary: {
            main: '#074078', // DOT Blue - main brand color
            light: '#0f5a9e', // Lighter DOT Blue
            dark: '#052d4f', // Darker DOT Blue
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#4a5568', // Professional Gray
            light: '#718096', // Light Gray
            dark: '#2d3748', // Dark Gray
            contrastText: '#ffffff',
        },
        error: {
            main: '#ab003c',
        },
        background: {
            default: '#fff',
        },
    },
    typography: {
        fontFamily: [
            'system-ui', 'sans-serif',
        ].join(','),
        subheading: {
            fontFamily: [
                'system-ui', 'sans-serif',
            ].join(',')
        },
        h6: {
            color: "inherit"
        },
       // fontSize: 16, // ✅ Increased from 13 to 16 for better readability
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
    },
    overrides: {
        MuiContainer: {
            root: {
                maxWidth: {
                    xs: '100%',  // for screens smaller than 600px
                    sm: '600px',  // for screens larger than 600px
                    md: '960px',  // for screens larger than 960px
                    lg: '1280px',  // for screens larger than 1280px
                    xl: '1920px',  // for screens larger than 1920px
                },
            },
        },
        MuiCssBaseline: {
            '@global': {
                'input:-internal-autofill-selected': {
                    backgroundColor: 'transparent !important',
                    boxShadow: '0 0 0 1000px white inset !important',
                    '-webkit-box-shadow': '0 0 0 1000px white inset !important',
                    '-webkit-text-fill-color': '#000 !important',
                    paddingTop: '1px',
                    marginTop: '5px',
                },
                '*::-webkit-scrollbar': {
                    width: '0.3em',
                    height: '0.45em',
                },
                '*::-webkit-scrollbar-track': {
                    '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: 'grey',
                    borderRadius: '10px',
                    outline: '1px solid grey'
                },
                '*::-webkit-scrollbar-thumb:hover': {
                    width: '1em',
                },
                '*::-webkit-scrollbar:hover': {
                    width: '1em',
                },
            }
        },
        MuiFormControl: {
            root: {
                zIndex: 'auto',
                '&.Mui-required': {
                    borderColor: 'red',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    '& .MuiInputBase-root': {
                        borderColor: 'red',
                    },
                    '& .MuiInputLabel-root': {
                        color: 'red',
                    },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: 'red',
                        },
                    },
                },
            },
        },
        // MuiTextField: {
        //     defaultProps: {
        //         size: 'small',
        //         margin: 'normal'
        //     },
        // },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    backgroundColor: '#333',
                    color: '#fff',
                },
                arrow: {
                    color: '#333',
                },
                popper: {
                    zIndex: 1500,
                },
            },
            // defaultProps: {
            //     placement: 'top',
            //     arrow: true,
            // },
        },
        MuiButton: {
            text: {
                textTransform: 'none',
            },
            root: {
                textTransform: 'none'
            },
            // defaultProps: {
            //     size: 'small',
            // },
        },
        MuiFab: {
            // defaultProps: {
            //     size: 'small',
            // },
            root: {
                borderRadius: '8px',
                size: 'small',
                boxShadow: 'none',
                padding: '0px !important'
            },
        },
        MuiIconButton: {
            // defaultProps: {
            //     size: 'small',
            //     padding: '0px !important'
            // },
            colorPrimary: {
              backgroundColor: 'linear-gradient(135deg, #0f5a9e 0%, #fafafa 100%)',
                borderRadius: '8px'
            }
        },
        MuiCheckbox: {
            // defaultProps: {
            //     size: 'small',
            // },
            root: {
                backgroundColor: 'white !important',
            }
        },
        MuiRadio: {
            // defaultProps: {
            //     size: 'small',
            // },
            root: {
                paddingTop: 8,
                backgroundColor: 'rgba(255, 255, 255,0)',// 50% transparent white
            }
        },
        MuiSwitch: {
            // defaultProps: {
            //     size: 'small',
            // },
        },
        MuiSelect: {
            paddingTop: '3px !important',
            // defaultProps: {
            //     size: 'small',
            //     margin: 'normal'
            // },
        },
        MuiFilledInput: {
            // defaultProps: {
            //     size: 'small',
            // },
        },
        MuiInputLabel: {
            // defaultProps: {
            //     size: 'small',
            // },
        },
        MuiAutocomplete: {
            // defaultProps: {
            //     size: 'small',
            //     margin: 'normal'
            // },
        },
        // MuiFormControl: {
        //     defaultProps: {
        //         size: 'small',
        //         margin: 'normal'
        //     },
        // },
        MuiListItemIcon: {
            // defaultProps: {
            //     size: 'small',
            // },
            root: {
                minWidth: '30px !important'
            }

        },
        MuiListItemText: {
            // defaultProps: {
            //     size: 'small',
            // },
        },
        MuiMenuItem: {
            // defaultProps: {
            //     size: 'small',
            //     margin: 'normal'
            // },
        },
        MuiCardContent: {
            // defaultProps: {
            //     size: 'small',
            //     margin: 'normal'
            // },
        },
        // MuiFab: {
        //     root: {
        //         boxShadow: '0px 0px 2px 0px '
        //     },
        //     sizeSmall: {
        //         width: '30px',
        //         height: '30px',
        //         minHeight: '30px',
        //         padding: '0px'
        //     },
        //     primary: {
        //         color: '#00355f !important',
        //         backgroundColor: '#fafafa !important',
        //     },
        //     secondary: {
        //         color: '#00355f !important',
        //         backgroundColor: '#fafafa !important'
        //     },

        // },
        // MuiButton: {
        //     text: {
        //         textTransform: 'none',
        //     },
        //     textPrimary: {
        //         color: '#00355f',
        //     },
        //     containedPrimary: {
        //         color: '#fafafa !important',
        //         backgroundColor: '#00355f !important'
        //     },
        //     root: {
        //         textTransform: 'none'
        //     }
        // },
        // MuiIcon: {
        //     root: {
        //         lineHeight: 'initial'
        //     }

        // },

        // MuiCheckbox: {
        //     colorPrimary: {
        //         color: '#00355f !important',
        //     },
        //     colorSecondary: {
        //         color: '#00355f !important',
        //     }
        // },
        // MuiListItemIcon: {
        //     root: {
        //         minWidth: '35px'
        //     }
        // },
        // MuiSwitch: {
        //     colorPrimary: {
        //         color: '#1976d2 !important',
        //     },
        //     colorSecondary: {
        //         color: '#1976d2 !important',
        //     }
        // },
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: colors.white,
                color: '#212529'
            },
            colorSecondary: {
                backgroundColor: colors.white,
                color: '#00355f !important'
            },
            colorDefault: {
                //color: '#fafafa !important',
                backgroundColor: colors.white,
                color: '#42a5f5 !important'
            }
        },
        MuiToolbar: {
            root: {
                minHeight: '48px'
            },
            regular: {
                minHeight: '48px'
            },
            dense: {
                minHeight: '0px'
            }


        },
        MuiTypography: {
            body2: {
                fontWeight: 400,
            },
            caption: {
                color: '#grey',
                fontSize: '0.875rem !important',
                fontWeight: '500 !important',
                //  color: '#697586 !important',
                // fontSize: '1rem !important',
            },
            h6: {
                color: '#808080',
                fontSize: '18px !important',
                fontWeight: '500 !important',
            },
            subtitle1: {
                color: '#808080',
                fontWeight: '500 !important',
                fontSize: '0.875rem !important',
            },
            subtitle2: {
                fontWeight: '500 !important',
                fontSize: '0.875rem !important',
            },
            displayBlock: {
                display: 'block',
                color: 'black',
            },
            colorPrimary: {
                color: '#3f51b5'
            },
        },
        // MuiTypography: {
        //     colorPrimary: {
        //         color: '#00355f'
        //     },
        //     colorSecondary: {
        //         color: '#1f1d1d !important'
        //     },
        //     section: {
        //         color: '#ffffff !important'
        //     }

        // },
        // MuiFormControl: {
        //     root: {
        //         zIndex: 'auto',
        //         marginTop: '5px',
        //         // margin: '2px'
        //     }
        // },
        MuiExpansionPanel: {
            root: {
                MuiExpanded: false
            }
        },
        MuiFormGroup: {
            root: {
                [theme.breakpoints.up('xs')]: {
                    marginTop: '25px',  // for screens larger than 0px
                },
                [theme.breakpoints.up('sm')]: {
                    marginTop: '20px',  // for screens larger than 600px
                },
                [theme.breakpoints.up('md')]: {
                    marginTop: '15px',  // for screens larger than 960px
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: '10px',  // for screens larger than 1280px
                },
                [theme.breakpoints.up('xl')]: {
                    marginTop: '5px',  // for screens larger than 1920px
                },
            },
        },
        MuiFormControlLabel: {
            label: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
            root: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
        },
        MuiInputBase: {
            root: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
            input: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: 'black',
                        cursor: 'not-allowed',
                    },
                },
            },
            // defaultProps: {
            //     size: 'small',
            //     margin: 'normal'
            // },
            root: {
                [theme.breakpoints.up('xs')]: {
                    marginTop: '25px',  // for screens larger than 0px
                },
                [theme.breakpoints.up('sm')]: {
                    marginTop: '20px',  // for screens larger than 600px
                },
                [theme.breakpoints.up('md')]: {
                    marginTop: '15px',  // for screens larger than 960px
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: '10px',  // for screens larger than 1280px
                },
                [theme.breakpoints.up('xl')]: {
                    marginTop: '5px',  // for screens larger than 1920px
                },
            }
        },
        // MuiInputLabel: {
        //     root: {
        //         marginBottom: {
        //             xs: theme.spacing(1),  // for screens smaller than 600px
        //             sm: theme.spacing(2),  // for screens larger than 600px
        //             md: theme.spacing(3),  // for screens larger than 960px
        //             lg: theme.spacing(4),  // for screens larger than 1280px
        //             xl: theme.spacing(5),  // for screens larger than 1920px
        //         },
        //     },
        //     formControl: {
        //         marginTop: '0px'
        //     }
        // },
        MuiLinearProgress: {
            root: {
                height: 5
            }
        },
        MuiTabs: {
            root: {
                minHeight: '0px'
            }
        },
        MuiTab: {
            root: {
                'text-transform': 'capitalize',
            },
            textColorPrimary: {
                "&.Mui-selected": {
                    color: '#00355f !important',
                }
            },
        },
        MuiBox: {
            root: {
                padding: '0px'
            }
        },
        // MuiButtonBase: {
        //     // colorPrimary: {
        //     //     color: '#00355f !important',
        //     //     backgroundColor: '#fafafa !important',
        //     //     boxShadow: '0px 0px 2px 0px '
        //     // },
        //     // secondary: {
        //     //     color: '00355f !important',
        //     //     backgroundColor: '#fafafa !important',
        //     //     boxShadow: '0px 0px 2px 0px '
        //     // },
        //     // colorSecondary: {
        //     //     color: '00355f !important',
        //     //     backgroundColor: '#fafafa !important'
        //     // },
        // },
        // MuiIconButton: {
        //     root: {
        //         padding: '3px'
        //     }
        // },
        MuiAccordionDetails: {
            root: {
                padding: '0px'
            }
        },
        MuiFormLabel: {
            root: {
                color: '#6c757d',
                fontWeight: '600'
            },
            asterisk: {
                color: 'red',
            }
        },
        MuiMenu: {
            paper: {
                maxHeight: '250px'
            }
        },
        PrivateTabIndicator: {
            colorPrimary: {
                color: '#00355f',
                backgroundColor: '#00355f'
            }
        },
        MuiMobileStepper: {
            dotActive: {
                backgroundColor: '#00355f'
            }
        },
        // MuiPaper: {
        //     root: {
        //         // borderRadius: '5px'
        //     }
        // },
        MuiListItem: {
            // defaultProps: {
            //     size: 'small',
            // },
            root: {
                '&:hover': {
                    backgroundColor: '#ede7f6 !important',  // Replace with your desired color
                    color: '#673ab7'
                },
                paddingTop: '5px !important',
                paddingBottom: '5px !important'
            },
        },
        MuiButtonBase: {
            // defaultProps: {
            //     size: 'small',
            //     margin: 'normal',
            //     padding: '0px',

            // },
        },
        // MuiBox: {
        //     root: {
        //         padding: '0px'
        //     }
        // },   
        PrivateSwitchBase: {
            root: {
                paddingLeft: '9px',
                paddingRight: '0px',
                paddingTop: '0px',
                paddingBottom: '5px',

            }
        }
    }
});

export const apps_theme = createTheme({
    palette: {
        primary: {
            main: '#074078',
        },
        secondary: {
            main: '#475569',
        },
        error: {
            main: '#C5050C',
        },
        background: {
            default: '#F8FAFC',
        },
    },
    typography: {
        fontFamily: [
            'system-ui', 'sans-serif',
        ].join(','),
        subheading: {
            fontFamily: [
                'system-ui', 'sans-serif',
            ].join(',')
        },
        h6: {
            color: "inherit"
        },
        fontSize: 13,
    },
    spacing: 2,
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '*::-webkit-scrollbar': {
                    width: '0.9em',
                    height: '0.5em',
                },
                '*::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                    borderRadius: '10px',
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888',
                    borderRadius: '10px',
                    border: '2px solid #f1f1f1',
                },
                '*::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#555',
                },
                '*::-webkit-scrollbar-corner': {
                    backgroundColor: '#f1f1f1',
                },
            },
        },
        MuiFormControl: {
            root: {
                zIndex: 'auto',
                marginBottom: '4px',
                '& .MuiFormLabel-root': {
                    color: '#003B5C !important',
                    fontWeight: 500,
                    '&.Mui-focused': {
                        color: '#003B5C !important',
                        fontWeight: 600,
                    },
                },
            },
        },
        MuiTextField: {
            root: {
                marginBottom: '4px',
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: 'transparent !important',
                        borderWidth: '1px !important',
                        borderBottomColor: 'rgba(0, 59, 92, 0.3) !important',
                    },
                    '&:hover fieldset': {
                        borderColor: 'transparent !important',
                        borderBottomColor: 'rgba(0, 59, 92, 0.5) !important',
                        borderWidth: '1px !important',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#003B5C !important',
                        borderWidth: '1.5px !important',
                    },
                },
                '& .MuiFormLabel-root': {
                    color: '#003B5C !important',
                    fontWeight: 500,
                    '&.Mui-focused': {
                        color: '#003B5C !important',
                        fontWeight: 600,
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    backgroundColor: '#333',
                    color: '#fff',
                },
                arrow: {
                    color: '#333',
                },
                popper: {
                    zIndex: 1500,
                },
            },
        },
        MuiButton: {
            text: {
                textTransform: 'none',
            },
            root: {
                textTransform: 'none !important',
                padding: 0
            },
        },
        MuiButtonBase: {
            root: {
                textTransform: 'none !important',
            },
        },
        MuiFab: {
            root: {
                borderRadius: '8px',
                boxShadow: 'none',
                padding: '0px !important',
                color: '#003B5C',
                backgroundColor: 'rgb(237, 231, 246)',
                '&:hover': {
                    color: 'white',
                    backgroundColor: '#003B5C',
                },
            },
        },
        MuiIconButton: {
            colorPrimary: {
                color: '#003B5C !important',
                borderRadius: '8px'
            }
        },
        MuiCheckbox: {
            root: {
                backgroundColor: 'white !important',
            }
        },
        MuiRadio: {
            root: {
                paddingTop: 8,
                backgroundColor: 'rgba(255, 255, 255, 0)',
            }
        },
        MuiInputLabel: {
            root: {
                color: '#003B5C',
                fontWeight: 500,
                fontSize: '1.05rem',
                backgroundColor: 'transparent',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                pointerEvents: 'none',
                '&.Mui-focused': {
                    color: '#003B5C !important',
                    fontWeight: 600,
                },
                '&.MuiInputLabel-shrink': {
                    color: '#003B5C !important',
                    fontWeight: 600,
                    fontSize: '1.05rem',
                    backgroundColor: 'transparent',
                    padding: '0 3px',
                    transform: 'translate(12px, -9px) scale(0.8)',
                },
                '&.Mui-error': {
                    color: '#C5050C',
                    '&.Mui-focused': {
                        color: '#C5050C',
                    },
                },
            },
            outlined: {
                transform: 'translate(12px, 14px) scale(1)',
                zIndex: 1,
                '&.MuiInputLabel-shrink': {
                    transform: 'translate(12px, -9px) scale(0.8)',
                },
            },
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: '6px',
                backgroundColor: 'rgba(0, 59, 92, 0.045)',
                transition: 'all 0.2s ease',
                overflow: 'hidden',
                padding: '0px',
                margin: '1px 0',
                '& fieldset': {
                    borderColor: 'transparent !important',
                    borderWidth: '1px !important',
                    borderBottomColor: 'rgba(0, 59, 92, 0.3) !important',
                },
                '&:hover': {
                    backgroundColor: 'rgba(0, 59, 92, 0.065)',
                    '& fieldset': {
                        borderColor: 'transparent !important',
                        borderBottomColor: 'rgba(0, 59, 92, 0.5) !important',
                        borderWidth: '1px !important',
                    },
                },
                '&.Mui-focused': {
                    backgroundColor: 'rgba(0, 59, 92, 0.04)',
                    '& fieldset': {
                        borderColor: '#003B5C !important',
                        borderWidth: '1.5px !important',
                    },
                },
                '&.Mui-error': {
                    backgroundColor: 'rgba(197, 5, 12, 0.04)',
                    '& fieldset': {
                        borderColor: '#C5050C !important',
                        borderWidth: '1.5px !important',
                    },
                },
            },
            input: {
                padding: '8px 12px',
                color: '#111827',
                fontWeight: 400,
                lineHeight: 1.25,
                '&::placeholder': {
                    color: '#9ca3af',
                    opacity: 1,
                },
            },
            notchedOutline: {
                borderRadius: '6px',
                '& legend': {
                    fontSize: '0.85em',
                },
            },
        },
        MuiGrid: {
            item: {
                paddingTop: '0.5px',
                paddingLeft: '0.5px',
            },
            container: {
                marginTop: '-0.5px',
                marginLeft: '-0.5px',
                width: 'calc(100% + 0.5px)',
            },
        },
        MuiCardContent: {
            root: {
                padding: '1px',
                '&:last-child': {
                    paddingBottom: '1px',
                },
            },
        },
        MuiListItemIcon: {
            root: {
                minWidth: '30px !important'
            }
        },
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: colors.white,
                color: '#212529'
            },
            colorSecondary: {
                backgroundColor: colors.white,
                color: '#003B5C !important'
            },
            colorDefault: {
                backgroundColor: colors.white,
                color: '#42a5f5 !important'
            }
        },
        MuiToolbar: {
            root: {
                minHeight: '48px'
            },
            regular: {
                minHeight: '48px'
            },
            dense: {
                minHeight: '0px'
            }
        },
        MuiTypography: {
            body2: {
                fontWeight: 400,
            },
            caption: {
                fontSize: '0.875rem !important',
                fontWeight: '500 !important',
            },
            h6: {
                color: '#808080',
                fontSize: '18px !important',
                fontWeight: '500 !important',
            },
            subtitle1: {
                color: '#808080',
                fontWeight: '500 !important',
                fontSize: '0.875rem !important',
            },
            subtitle2: {
                fontWeight: '500 !important',
                fontSize: '0.875rem !important',
            },
            displayBlock: {
                display: 'block',
                color: 'black',
            },
            colorPrimary: {
                color: '#003B5C'
            },
        },
        MuiExpansionPanel: {
            root: {
                MuiExpanded: false
            }
        },
        MuiFormGroup: {
            root: {
                [theme.breakpoints.up('xs')]: {
                    marginTop: '25px',
                },
                [theme.breakpoints.up('sm')]: {
                    marginTop: '20px',
                },
                [theme.breakpoints.up('md')]: {
                    marginTop: '15px',
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: '10px',
                },
                [theme.breakpoints.up('xl')]: {
                    marginTop: '5px',
                },
            },
        },
        MuiFormControlLabel: {
            label: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
            root: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
        },
        MuiInputBase: {
            root: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
            input: {
                '&.Mui-disabled': {
                    color: 'black',
                    cursor: 'not-allowed',
                    '&:hover': {
                        cursor: 'not-allowed',
                    },
                },
            },
        },
        MuiInput: {
            root: {
                [theme.breakpoints.up('xs')]: {
                    marginTop: '25px',
                },
                [theme.breakpoints.up('sm')]: {
                    marginTop: '20px',
                },
                [theme.breakpoints.up('md')]: {
                    marginTop: '15px',
                },
                [theme.breakpoints.up('lg')]: {
                    marginTop: '10px',
                },
                [theme.breakpoints.up('xl')]: {
                    marginTop: '5px',
                },
            }
        },
        MuiLinearProgress: {
            root: {
                height: 5
            }
        },
        MuiTabs: {
            root: {
                minHeight: '0px'
            }
        },
        MuiTab: {
            root: {
                'text-transform': 'capitalize',
            },
            textColorPrimary: {
                "&.Mui-selected": {
                    color: '#003B5C !important',
                }
            },
        },
        MuiBox: {
            root: {
                padding: '0px'
            }
        },
        MuiAccordionDetails: {
            root: {
                padding: '0px'
            }
        },
        MuiFormLabel: {
            root: {
                color: '#003B5C',
                fontWeight: 500
            },
            asterisk: {
                color: 'red',
            }
        },
        MuiMenu: {
            paper: {
                maxHeight: '250px'
            }
        },
        PrivateTabIndicator: {
            colorPrimary: {
                color: '#003B5C',
                backgroundColor: '#003B5C'
            }
        },
        MuiMobileStepper: {
            dotActive: {
                backgroundColor: '#003B5C'
            }
        },
        MuiPaper: {
            root: {
            }
        },
        MuiListItem: {
            root: {
                '&:hover': {
                    backgroundColor: 'rgba(0, 59, 92, 0.08) !important',
                    color: '#003B5C'
                },
                paddingTop: '5px !important',
                paddingBottom: '5px !important'
            },
        },
        PrivateSwitchBase: {
            root: {
                paddingLeft: '9px',
                paddingRight: '0px',
                paddingTop: '0px',
                paddingBottom: '5px',
            }
        }
    }
});

export const apps_theme_custom = createTheme({
    palette: {
        primary: {
            main: '#074078',
        },
        secondary: {
            main: '#475569',
        },
        error: {
            main: '#C5050C',
        },
        background: {
            default: '#F8FAFC',
        },
    },
    typography: {
        fontFamily: [
            'system-ui', 'sans-serif',
        ].join(','),
        subheading: {
            fontFamily: [
                'system-ui', 'sans-serif',
            ].join(',')
        },
        h6: {
            color: "inherit"
        },
        fontSize: 13,
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '*::-webkit-scrollbar': {
                    width: '0.9em',
                    height: '0.5em',
                },
                '*::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                    borderRadius: '10px',
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888',
                    borderRadius: '10px',
                    border: '2px solid #f1f1f1',
                },
                '*::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#555',
                },
                '*::-webkit-scrollbar-corner': {
                    backgroundColor: '#f1f1f1',
                },
            }
        },
        MuiFormControl: {
            root: {
                zIndex: 'auto',
                marginBottom: '4px',
                '& .MuiFormLabel-root': {
                    color: '#003B5C !important',
                    fontWeight: 500,
                    '&.Mui-focused': {
                        color: '#003B5C !important',
                        fontWeight: 600,
                    },
                },
            },
        },
        MuiTextField: {
            root: {
                marginBottom: '4px',
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: 'transparent !important',
                        borderWidth: '1px !important',
                        borderBottomColor: 'rgba(0, 59, 92, 0.3) !important',
                    },
                    '&:hover fieldset': {
                        borderColor: 'transparent !important',
                        borderBottomColor: 'rgba(0, 59, 92, 0.5) !important',
                        borderWidth: '1px !important',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#003B5C !important',
                        borderWidth: '1.5px !important',
                    },
                },
                '& .MuiFormLabel-root': {
                    color: '#003B5C !important',
                    fontWeight: 500,
                    '&.Mui-focused': {
                        color: '#003B5C !important',
                        fontWeight: 600,
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    backgroundColor: '#333',
                    color: '#fff',
                },
                arrow: {
                    color: '#333',
                },
                popper: {
                    zIndex: 1500,
                },
            },
        },
        MuiButton: {
            text: {
                textTransform: 'none',
            },
            root: {
                textTransform: 'none !important',
                padding: 0
            },
        },
        MuiButtonBase: {
            root: {
                textTransform: 'none !important',
            },
        },
        MuiFab: {
            root: {
                borderRadius: '8px',
                boxShadow: 'none',
                padding: '0px !important',
                color: '#003B5C',
                backgroundColor: 'rgb(237, 231, 246)',
                '&:hover': {
                    color: 'white',
                    backgroundColor: '#003B5C',
                },
            },
        },
        MuiIconButton: {
            colorPrimary: {
                color: '#003B5C !important',
                borderRadius: '8px'
            }
        },
        MuiCheckbox: {
            root: {
                backgroundColor: 'white !important',
            }
        },
        MuiRadio: {
            root: {
                paddingTop: 8,
                backgroundColor: 'rgba(255, 255, 255, 0)',
            }
        },
        MuiInputLabel: {
            root: {
                color: '#003B5C',
                fontWeight: 500,
                fontSize: '1.05rem',
                backgroundColor: 'transparent',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                pointerEvents: 'none',
                '&.Mui-focused': {
                    color: '#003B5C !important',
                    fontWeight: 600,
                },
                '&.MuiInputLabel-shrink': {
                    color: '#003B5C !important',
                    fontWeight: 600,
                    fontSize: '1.05rem',
                    backgroundColor: 'transparent',
                    padding: '0 3px',
                    transform: 'translate(12px, -9px) scale(0.8)',
                },
                '&.Mui-error': {
                    color: '#C5050C',
                    '&.Mui-focused': {
                        color: '#C5050C',
                    },
                },
            },
            outlined: {
                transform: 'translate(12px, 14px) scale(1)',
                zIndex: 1,
                '&.MuiInputLabel-shrink': {
                    transform: 'translate(12px, -9px) scale(0.8)',
                },
            },
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: '6px',
                backgroundColor: 'rgba(0, 59, 92, 0.045)',
                transition: 'all 0.2s ease',
                overflow: 'hidden',
                padding: '0px',
                margin: '1px 0',
                '& fieldset': {
                    borderColor: 'transparent !important',
                    borderWidth: '1px !important',
                    borderBottomColor: 'rgba(0, 59, 92, 0.3) !important',
                },
                '&:hover': {
                    backgroundColor: 'rgba(0, 59, 92, 0.065)',
                    '& fieldset': {
                        borderColor: 'transparent !important',
                        borderBottomColor: 'rgba(0, 59, 92, 0.5) !important',
                        borderWidth: '1px !important',
                    },
                },
                '&.Mui-focused': {
                    backgroundColor: 'rgba(0, 59, 92, 0.04)',
                    '& fieldset': {
                        borderColor: '#003B5C !important',
                        borderWidth: '1.5px !important',
                    },
                },
                '&.Mui-error': {
                    backgroundColor: 'rgba(197, 5, 12, 0.04)',
                    '& fieldset': {
                        borderColor: '#C5050C !important',
                        borderWidth: '1.5px !important',
                    },
                },
            },
            input: {
                padding: '8px 12px',
                color: '#111827',
                fontWeight: 400,
                lineHeight: 1.25,
                '&::placeholder': {
                    color: '#9ca3af',
                    opacity: 1,
                },
            },
            notchedOutline: {
                borderRadius: '6px',
                '& legend': {
                    fontSize: '0.85em',
                },
            },
        },
        MuiGrid: {
            item: {
                paddingTop: '0.5px',
                paddingLeft: '0.5px',
            },
            container: {
                marginTop: '-0.5px',
                marginLeft: '-0.5px',
                width: 'calc(100% + 0.5px)',
            },
        },
        MuiCardContent: {
            root: {
                padding: '1px',
                '&:last-child': {
                    paddingBottom: '1px',
                },
            },
        },
        MuiListItemIcon: {
            root: {
                minWidth: '30px !important'
            }
        },
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: colors.white,
                color: '#212529'
            },
            colorSecondary: {
                backgroundColor: colors.white,
                color: '#003B5C !important'
            },
            colorDefault: {
                backgroundColor: colors.white,
                color: '#42a5f5 !important'
            }
        },
        MuiToolbar: {
            dense: {
                minHeight: '5px !important',
                '@media (min-width: 60px)': {
                    minHeight: '5px !important',
                },
            },
        },
        MuiAccordionDetails: {
            root: {
                padding: '0px'
            }
        },
        MuiFormLabel: {
            root: {
                color: '#003B5C',
                fontWeight: 500
            },
            asterisk: {
                color: 'red',
            }
        },
        MuiMenu: {
            paper: {
                maxHeight: '250px'
            }
        },
        PrivateTabIndicator: {
            colorPrimary: {
                color: '#003B5C',
                backgroundColor: '#003B5C'
            }
        },
        MuiMobileStepper: {
            dotActive: {
                backgroundColor: '#003B5C'
            }
        },
        MuiPaper: {
            root: {
            }
        },
        MuiListItem: {
            root: {
                '&:hover': {
                    backgroundColor: 'rgba(0, 59, 92, 0.08) !important',
                    color: '#003B5C'
                },
                paddingTop: '5px !important',
                paddingBottom: '5px !important'
            },
        },
        PrivateSwitchBase: {
            root: {
                paddingLeft: '9px',
                paddingRight: '0px',
                paddingTop: '0px',
                paddingBottom: '5px',
            }
        }
    }
});
